import Portal from "@/managers/portal"
import JwtAuthenticationMethod from "@/managers/authentication/jwtAuthenticationMethod"
import {watch} from "@/store/store"

class StashedAccessToken extends JwtAuthenticationMethod {
	private static authenticationMethod = "StashedAccessToken"

	constructor() {
		super(localStorage, "AccessToken", false)

		watch(
			() => Portal.accessToken,
			token => {
				if (token !== null)
					this.validateAndSetToken(token)
				else
					this.clear()
			}
		)
	}

	protected loginWithToken(token: string): Promise<string | null> {
		Portal.client.setAccessToken(token, StashedAccessToken.authenticationMethod)

		return Promise.resolve(null)
	}
}

export default new StashedAccessToken()
